export default __webpack_public_path__ + "static/media/greenDropDown.1c562494.svg";